// Badge colour per request status, shared by My Requests and the Activity Log so
// the same status cannot render two different colours.
//
// Submitted only ever appears on My Requests - the Activity Log lists persisted
// requests, which have moved past it - but keeping one map avoids the two drifting.
export const REQUEST_STATUS_COLOR = {
  Submitted: 'primary',
  Pending: 'warning',
  Approved: 'info',
  Applied: 'success',
  Failed: 'danger',
  Rejected: 'dark',
  Cancelled: 'secondary',
}
